import { Injectable } from '@angular/core';
import { PatientApiService } from '@frontend/shared/patient/data-access/src';
import { TagApiService } from '@frontend/shared/tag/data-access/src/lib/tag-api/tag-api.service';
import { concatMap, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CheckInKioskFeatureCheckInService {
  constructor(
    private tagService: TagApiService,
    private patientService: PatientApiService
  ) {}

  checkIn(data) {
    const getTagByValue = (label) =>
      this.tagService.get({ label }).pipe(
        map((tags: any[]) => tags[0]),
        tap((tag) => {
          if (!tag) {
            throw { errorCode: 'TAG_NOT_FOUND' };
          }
        })
      );
    return getTagByValue(data.tag).pipe(
      concatMap((tag: any) =>
        this.patientService
          .get({ tag_id: tag.id.toString(), department_id: data.department_id })
          .pipe(
            map((patients: any[]) => patients[0]),
            concatMap((patient: any) => {
              const payload = {
                ...data,
                phone_number: data.cellphone,
                tag_id: tag.id,
              };
              if (!patient) {
                return this.patientService.create(payload);
              }
              return this.patientService.getSecure(patient.securable_id).pipe(
                concatMap((securableData: { body: any }) =>
                  this.patientService.update({
                    ...payload,
                    ...patient,
                    first_name: payload.first_name || securableData.body.first_name,
                    last_name: payload.last_name || securableData.body.last_name,
                    phone_number: payload.phone_number || securableData.body.phone_number,
                    assigned_staff_id:
                      payload.assigned_staff_id || patient.assigned_staff_id,
                    appointment_time_utc:
                      payload.appointment_time_utc || patient.appointment_time_utc,
                  })
                )
              );
            })
          )
      )
    );
  }
}
